import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import notifications from 'vue-notification'
import { formatValue } from '@/filters/formatting'

Vue.config.productionTip = false
Vue.filter('uppercase', (value: string) => {
  return value.toUpperCase()
})
Vue.filter('formatValue', formatValue)

Vue.use(notifications)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
